import { useEffect } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import api from '~/services/api';
import { useWebsocket } from './useWebsocket';

const loadChatWoot = () => {
  window.chatwootSettings = {
    position: 'right',
    type: 'standard',
    launcherTitle: 'Fale conosco no chat',
  };
  var BASE_URL = 'https://chatwoot.takeat.cloud';
  var g = document.createElement('script');

  g.src = BASE_URL + '/packs/js/sdk.js';
  g.defer = true;
  g.async = true;

  g.onload = function () {
    if (window.chatwootSDK && window.chatwootSDK.run) {
      window.chatwootSDK.run({
        websiteToken: 'FNDKaRvRLpcvmqVaWZMR19A5',
        baseUrl: BASE_URL,
      });
    }
  };

  document.body.appendChild(g);
};

function loadHubspot() {
  window.hsConversationsSettings = { loadImmediately: false };
  var s = document.createElement('script');

  s.type = 'text/javascript';
  s.id = 'hs-script-loader';
  s.async = true;
  s.defer = true;
  s.src = '//js.hs-scripts.com/24373118.js';

  document.body.appendChild(s);
}

const setElementDisplay = (element, shouldShow) => {
  console.log('element:', element);
  if (element) {
    element.style.setProperty(
      'display',
      shouldShow ? 'unset' : 'none',
      'important'
    );
  }
};

export const useChat = () => {
  // const queryClient = useQueryClient();
  // const { data: chatData } = useQuery({
  //   queryKey: ['chat'],
  //   queryFn: () => {
  //     return api.get('/public/settings/chat');
  //   },
  //   retry: 0,
  //   staleTime: Infinity,
  // });

  // useWebsocket('update-chat-provider', (data) => {
  //   queryClient.setQueryData(['chat'], () => {
  //     return { data: data.value };
  //   });
  // });

  // const chatwootBubbleEl = document.getElementById('cw-bubble-holder');
  // const chatwootWidgetEl = document.getElementById('cw-widget-holder');
  // const hubspotEl = document.getElementById(
  //   'hubspot-messages-iframe-container'
  // );

  // useEffect(() => {
  //   const chatProvider = chatData?.data;

  //   const isChatwoot = chatProvider === 'chatwoot';
  //   const isHubspot = chatProvider === 'hubspot';

  //   setElementDisplay(chatwootBubbleEl, isChatwoot);
  //   setElementDisplay(chatwootWidgetEl, isChatwoot);
  //   setElementDisplay(hubspotEl, isHubspot);
  // }, [chatData?.data, chatwootBubbleEl, chatwootWidgetEl, hubspotEl]);

  useEffect(() => {
    // loadChatWoot();
    loadHubspot();
  }, []);
};
